import { render, staticRenderFns } from "./leftThree.vue?vue&type=template&id=4b956c58&scoped=true&"
import script from "./leftThree.vue?vue&type=script&lang=js&"
export * from "./leftThree.vue?vue&type=script&lang=js&"
import style0 from "./leftThree.vue?vue&type=style&index=0&id=4b956c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b956c58",
  null
  
)

export default component.exports